import * as roles from '@/constants/roles';
import { PROFILE, OWNER_PROFILE, INVOICES, LOGIN } from '@/constants/routes';
import { useUserStore } from '@/stores/user';

export default function startPageRedirect() {
  const userRole = useUserStore().role;

  if (userRole === roles.CLIENT) {
    return { name: PROFILE };
  }

  if (userRole === roles.OWNER) {
    return { name: OWNER_PROFILE };
  }

  if (userRole === roles.MANAGEMENT_COMPANY_EMPLOYEE) {
    return { name: INVOICES };
  }

  return { name: LOGIN };
}
